<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">申诉管理</span>
      </div>
    </div>

    <div class="filter-box after-sale-filter">
      <Form :label-width="86" inline>
        <FormItem label="申诉状态:">
          <Select v-model="page.status" clearable class="filter-control">
            <Option :value="0">待审核</Option>
            <Option :value="1">已完成</Option>
            <Option :value="2">驳回</Option>
          </Select>
        </FormItem>

        <FormItem label="订单 ID:">
          <Input
            v-model.trim="page.orderId"
            placeholder="订单 ID"
            class="filter-control"
            @on-enter="getData(1)"
          />
        </FormItem>

        <FormItem label="手机号:">
          <Input
            v-model.trim="page.appealPhone"
            placeholder="申诉手机号"
            class="filter-control"
            @on-enter="getData(1)"
          />
        </FormItem>

        <FormItem label="合作伙伴:" v-if="!agent.tp">
          <Select
            v-model="page.agent_id"
            filterable
            remote
            clearable
            :remote-method="searchAgent"
            :loading="agentSearch.loading"
            class="filter-control"
          >
            <Option v-for="item in agentSearch.list" :value="item.id" :key="item.id">{{ item.agent_name || item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="申诉时间:">
          <DatePicker
            type="daterange"
            v-model="page.dateRange"
            @on-change="onDateRangeChange"
            placeholder="选择开始和结束时间"
            class="filter-date"
          />
          <RadioGroup
            type="button"
            v-model="quickDate"
            class="quick-date"
            @on-change="setQuickDate"
          >
            <Radio label="today">今日</Radio>
            <Radio label="yesterday">昨日</Radio>
            <Radio label="week">本周</Radio>
            <Radio label="month">本月</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem :label-width="0">
          <span class="btn-filter" @click="getData(1)">筛选</span>
          <span class="btn" @click="reset">清空</span>
        </FormItem>
      </Form>
    </div>

    <div style="position: relative">
      <Table size="small" :columns="columns" :data="data" :loading="tableLoading" />
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="page.p + 1"
          :total="total"
          :page-size="page.l"
          :page-size-opts="pageSizeOpts"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>

    <Modal width="760" title="申诉详情" v-model="detailModal.visible">
      <Spin fix v-if="detailModal.loading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
      <div v-if="detail.id" class="after-sale-detail">
        <Row :gutter="16">
          <Col span="12"><span class="label">订单 ID:</span>{{ detail.order_id || '-' }}</Col>
          <Col span="12"><span class="label">状态:</span>{{ detail.status_name || statusText(detail.status) }}</Col>
          <Col span="12"><span class="label">合作伙伴:</span>{{ detail.agent_name || '-' }}</Col>
          <Col span="12"><span class="label">站点:</span>{{ detail.site_name || '-' }}</Col>
          <Col span="12"><span class="label">设备:</span>{{ detail.machine_sn || '-' }}</Col>
          <Col span="12"><span class="label">申诉金额:</span>{{ detail.appeal_amount || '0.00' }}</Col>
          <Col span="12"><span class="label">退款金额:</span>{{ detail.refund_amount || '0.00' }}</Col>
          <Col span="12"><span class="label">手机号:</span>{{ detail.appeal_phone || '-' }}</Col>
          <Col span="12"><span class="label">创建时间:</span>{{ formatDateTime(detail.create_time) }}</Col>
          <Col span="12"><span class="label">审核时间:</span>{{ formatDateTime(detail.audit_time) }}</Col>
        </Row>
        <div class="detail-block">
          <span class="label">申诉类型:</span>{{ formatTypes(detail) }}
        </div>
        <div class="detail-block">
          <span class="label">文件 ID:</span>{{ formatArray(detail.file_ids) }}
        </div>
        <div class="detail-block">
          <span class="label">申诉描述:</span>{{ detail.description || '-' }}
        </div>
        <div class="detail-block" v-if="detail.audit_remark">
          <span class="label">审核备注:</span>{{ detail.audit_remark }}
        </div>
        <div class="image-list" v-if="normalizeImages(detail.images_url).length">
          <button
            v-for="(url, index) in normalizeImages(detail.images_url)"
            :key="index"
            type="button"
            @click="openImagePreview(url)"
          >
            <img :src="imageUrl(url)" />
          </button>
        </div>
      </div>
      <div slot="footer">
        <Button @click="detailModal.visible = false">关闭</Button>
      </div>
    </Modal>

    <Modal v-model="imagePreview.visible" title="图片预览" footer-hide width="80%">
      <div class="image-preview">
        <img v-if="imagePreview.url" :src="imagePreview.url" />
      </div>
    </Modal>

    <Modal width="420" :title="auditModal.status === 1 ? '通过申诉' : '驳回申诉'" v-model="auditModal.visible">
      <Form :label-width="90">
        <FormItem label="退款金额:" v-if="auditModal.status === 1">
          <InputNumber
            :active-change="false"
            :precision="2"
            :min="0"
            :step="0.01"
            style="width: 180px"
            v-model="auditModal.refundAmount"
          />
        </FormItem>
        <FormItem label="审核备注:">
          <Input v-model.trim="auditModal.auditRemark" type="textarea" :rows="4" placeholder="请输入审核备注" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="auditModal.visible = false">取消</Button>
        <Button type="primary" :loading="auditModal.loading" @click="submitAudit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '@/config'
import { GetTmallAfterSaleList, GetTmallAfterSaleDetail, AuditTmallAfterSale } from '@/api/tmall-after-sale'

export default {
  data () {
    return {
      tableLoading: false,
      data: [],
      total: 0,
      pageSizeOpts: [10, 20, 50, 100],
      quickDate: 'today',
      page: {
        p: 0,
        l: 10,
        status: '',
        orderId: '',
        appealPhone: '',
        agent_id: '',
        dateRange: []
      },
      agentSearch: {
        loading: false,
        list: []
      },
      detailModal: {
        visible: false,
        loading: false
      },
      detail: {},
      imagePreview: {
        visible: false,
        url: ''
      },
      auditModal: {
        visible: false,
        loading: false,
        id: '',
        status: 1,
        refundAmount: 0,
        auditRemark: ''
      },
      columns: [
        { width: 90, key: 'id', title: '申诉ID' },
        { width: 170, key: 'order_id', title: '订单ID', tooltip: true },
        { width: 100, key: 'status_name', title: '状态' },
        { width: 110, key: 'appeal_amount', title: '申诉金额' },
        { width: 110, key: 'refund_amount', title: '退款金额' },
        { width: 130, key: 'appeal_phone', title: '手机号' },
        { width: 140, key: 'agent_name', title: '合作伙伴', tooltip: true },
        { width: 130, key: 'site_name', title: '站点', tooltip: true },
        { width: 120, key: 'machine_sn', title: '设备', tooltip: true },
        {
          width: 180,
          key: 'feedbackTypes',
          title: '申诉类型',
          tooltip: true,
          render: (h, params) => h('span', this.formatTypes(params.row))
        },
        {
          minWidth: 220,
          key: 'description',
          title: '申诉描述',
          tooltip: true,
          render: (h, params) => h('span', params.row.description || '-')
        },
        {
          width: 170,
          key: 'create_time',
          title: '创建时间',
          render: (h, params) => h('span', this.formatDateTime(params.row.create_time))
        },
        {
          width: 170,
          key: 'audit_time',
          title: '审核时间',
          render: (h, params) => h('span', this.formatDateTime(params.row.audit_time))
        },
        {
          width: 180,
          key: 'operator',
          title: '操作',
          fixed: 'right',
          render: (h, params) => {
            const children = [
              h('Button', {
                props: { size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openDetail(params.row.id) }
              }, '详情')
            ]
            if (Number(params.row.status) === 0) {
              children.push(h('Button', {
                props: { size: 'small', type: 'primary' },
                style: { marginRight: '6px' },
                on: { click: () => this.openAudit(params.row, 1) }
              }, '通过'))
              children.push(h('Button', {
                props: { size: 'small', type: 'error' },
                on: { click: () => this.openAudit(params.row, 2) }
              }, '驳回'))
            }
            return h('div', children)
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      agent: 'agent'
    })
  },
  mounted () {
    if (this.agent.tp && Number(this.agent.is_tmall) !== 1) {
      this.$Message.error('无权访问天猫售后模块')
      this.$router.replace({ name: 'error_401' })
      return
    }
    this.setQuickDate('today')
    this.getData()
  },
  methods: {
    ...mapActions(['getUserInfo', 'getAgentList']),
    statusText (status) {
      const map = { 0: '待审核', 1: '已完成', 2: '驳回' }
      return map[Number(status)] || '-'
    },
    formatDateTime (value) {
      return value ? this.$moment(value, 'YYYY-MM-DD HH:mm:ss') : '-'
    },
    formatArray (value) {
      const arr = this.normalizeArray(value)
      return arr.length ? arr.join('、') : '-'
    },
    formatTypes (row) {
      if (row.feedbackTypes && row.feedbackTypes.length) {
        return row.feedbackTypes.map(item => item.name).join('、')
      }
      return this.formatArray(row.feedback_type_ids)
    },
    normalizeArray (value) {
      if (!value) return []
      if (value instanceof Array) return value
      try {
        const parsed = JSON.parse(value)
        return parsed instanceof Array ? parsed : []
      } catch (e) {
        return String(value).split(',').filter(Boolean)
      }
    },
    normalizeImages (value) {
      return this.normalizeArray(value)
    },
    imageUrl (url) {
      if (!url) return ''
      if (/^https?:\/\//.test(url)) return url
      return `${config.baseUrl.pro}${url}`
    },
    openImagePreview (url) {
      this.imagePreview.url = this.imageUrl(url)
      this.imagePreview.visible = true
    },
    onDateRangeChange () {
      this.quickDate = ''
      this.page.p = 0
    },
    setQuickDate (type) {
      this.quickDate = type
      this.page.p = 0
      const now = new Date()
      const today = this.$moment(now, 'YYYY-MM-DD')
      let start = today
      let end = today
      if (type === 'yesterday') {
        const yesterday = new Date(now)
        yesterday.setDate(now.getDate() - 1)
        start = this.$moment(yesterday, 'YYYY-MM-DD')
        end = start
      } else if (type === 'week') {
        const weekStart = new Date(now)
        const day = weekStart.getDay()
        weekStart.setDate(now.getDate() - day + (day === 0 ? -6 : 1))
        start = this.$moment(weekStart, 'YYYY-MM-DD')
      } else if (type === 'month') {
        start = this.$moment(now, 'YYYY-MM') + '-01'
      }
      this.page.dateRange = [start, end]
    },
    getParams () {
      const params = JSON.parse(JSON.stringify(this.page))
      if (params.status === '') delete params.status
      if (!params.orderId) delete params.orderId
      if (!params.appealPhone) delete params.appealPhone
      if (!params.agent_id) delete params.agent_id
      if (params.dateRange && params.dateRange[0] && params.dateRange[1]) {
        params.start = this.$moment(params.dateRange[0], 'YYYY-MM-DD')
        params.end = this.$moment(params.dateRange[1], 'YYYY-MM-DD')
      }
      delete params.dateRange
      return params
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      this.tableLoading = true
      GetTmallAfterSaleList(this.getParams()).then(res => {
        this.tableLoading = false
        const result = res.data
        if (!result || !result.status) {
          this.$Message.error((result && result.msg) || '获取申诉列表失败')
          return
        }
        this.data = result.data && result.data.data ? result.data.data : []
        this.total = result.data && result.data.total ? result.data.total : 0
      }).catch(() => {
        this.tableLoading = false
        this.$Message.error('获取申诉列表失败')
      })
    },
    reset () {
      this.page = {
        p: 0,
        l: this.page.l,
        status: '',
        orderId: '',
        appealPhone: '',
        agent_id: '',
        dateRange: []
      }
      this.setQuickDate('today')
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.page.p = 0
      this.getData()
    },
    searchAgent (query) {
      if (!query) return
      this.agentSearch.loading = true
      this.getAgentList({ cond: 'agent_name', value: query, is_del: 0, p: 0, l: 100 }).then(res => {
        this.agentSearch.loading = false
        this.agentSearch.list = res && res.data ? res.data : []
      }).catch(() => {
        this.agentSearch.loading = false
      })
    },
    openDetail (id) {
      this.detail = {}
      this.detailModal.visible = true
      this.detailModal.loading = true
      GetTmallAfterSaleDetail({ id }).then(res => {
        this.detailModal.loading = false
        const result = res.data
        if (!result || !result.status) {
          this.$Message.error((result && result.msg) || '获取申诉详情失败')
          return
        }
        this.detail = result.data || {}
      }).catch(() => {
        this.detailModal.loading = false
        this.$Message.error('获取申诉详情失败')
      })
    },
    openAudit (row, status) {
      this.auditModal = {
        visible: true,
        loading: false,
        id: row.id,
        status,
        refundAmount: status === 1 ? Number(row.appeal_amount || 0) : 0,
        auditRemark: ''
      }
    },
    submitAudit () {
      const data = {
        id: this.auditModal.id,
        status: this.auditModal.status === 1 ? 'DONE' : 'OVERRULE',
        auditRemark: this.auditModal.auditRemark
      }
      if (this.auditModal.status === 1) {
        data.refundAmount = this.auditModal.refundAmount
      }
      this.auditModal.loading = true
      AuditTmallAfterSale(data).then(res => {
        this.auditModal.loading = false
        const result = res.data
        if (!result || !result.status) {
          this.$Message.error((result && result.msg) || '审核失败')
          return
        }
        this.$Message.success('审核成功')
        this.auditModal.visible = false
        this.getData()
      }).catch(() => {
        this.auditModal.loading = false
        this.$Message.error('审核失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.after-sale-detail {
  line-height: 32px;

  .label {
    color: #808695;
    display: inline-block;
    margin-right: 8px;
  }

  .detail-block {
    margin-top: 8px;
    line-height: 24px;
  }

  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 12px;

    button {
      display: block;
      padding: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
    }

    img {
      display: block;
      width: 96px;
      height: 96px;
      object-fit: cover;
      border: 1px solid #e8eaec;
      border-radius: 4px;
    }
  }
}

.image-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;

  img {
    display: block;
    max-width: 100%;
    max-height: 75vh;
    object-fit: contain;
  }
}

.after-sale-filter {
  /deep/ .ivu-form-item {
    margin-bottom: 10px;
    margin-right: 14px;
  }

  /deep/ .ivu-form-item-label {
    padding-right: 8px;
  }

  .filter-control {
    width: 180px;
  }

  .filter-date {
    width: 240px;
  }

  .quick-date {
    margin-left: 8px;
    vertical-align: top;
  }

  .btn-filter {
    display: inline-block;
    background: #4788F7;
    padding: 9px 16px;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    line-height: 1;
  }

  .btn {
    display: inline-block;
    background: #fff;
    border: 1px solid #dedede;
    padding: 9px 16px;
    margin-left: 10px;
    border-radius: 5px;
    cursor: pointer;
    line-height: 1;
  }
}
</style>
